module.exports = __webpack_public_path__ + "img/kankou_5.dc75d257.jpg";